import { render, staticRenderFns } from "./goodsUnpackAdd.vue?vue&type=template&id=4bf8a938&"
import script from "./goodsUnpackAdd.vue?vue&type=script&lang=js&"
export * from "./goodsUnpackAdd.vue?vue&type=script&lang=js&"
import style0 from "./goodsUnpackAdd.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports